import { render } from "./StockWindow.vue?vue&type=template&id=61639954&scoped=true&ts=true"
import script from "./StockWindow.vue?vue&type=script&lang=ts"
export * from "./StockWindow.vue?vue&type=script&lang=ts"

import "./StockWindow.vue?vue&type=style&index=0&id=61639954&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61639954"]])

export default __exports__